import React from 'react';
import { useInView } from 'react-intersection-observer';

import Text from 'components/Text/Text';
import { fadeInUpMotion } from 'utils/styles/animations';

import * as S from './SideText.styles';

export interface SideTextProps {
  label: string;
  description: string;
  align: 'left' | 'right';
}

const defaultProps: Partial<SideTextProps> = {
  label: 'research',
  description: '-',
  align: 'right',
};

const SideText: React.FC<SideTextProps> = ({ label, description, align }) => {
  const [containerRef, inView] = useInView({ threshold: [0.25, 0.5, 0.75] });

  return (
    <S.Container
      ref={containerRef}
      role="article"
      aria-label={label}
      initial={fadeInUpMotion.initial}
      animate={inView ? fadeInUpMotion.animate : fadeInUpMotion.initial}
      transition={{ duration: 0.3 }}
    >
      <S.TextContainer align={align}>
        <S.TitleWrapper>
          <Text as="h6" text={label} size="titleMedium" />
        </S.TitleWrapper>

        <Text as="p" text={description} size="paragraphMedium" />
      </S.TextContainer>
    </S.Container>
  );
};

SideText.defaultProps = defaultProps;

export default SideText;
